import LogsController from './LogsController';

export default LogsController;